import { UntypedFormGroup } from '@angular/forms';
import { DSM3ColumnTable, DSM3SelectOption } from '@eredes/dsm3';
export class UserListViewModel {
  selectPaginationOption: DSM3SelectOption[] = [
    { label: '80', value: '80' },
    { label: '40', value: '40' },
    { label: '20', value: '20' },
  ];

  emptyLabel = 'Não foram encontrados utilizadores.';
  paginationPerPage = 20;
  currentUserRequestPage = 1;
  isErrorFromService = false;
  isEmptyList = false;
  formGroup: UntypedFormGroup;

  public columnsTable: DSM3ColumnTable[] = [
    { label: 'Nome', prop: 'userName' },
    { label: 'Nome de utilizador', prop: 'userAccount' },
    { label: 'Entidade', prop: 'retailerName' },
    { label: '', prop: 'edit' },
  ];
}
